// eslint-disable-next-line no-unused-vars
import React, { useCallback, useEffect, useState } from 'react';
import { any, object, func } from 'prop-types';
import debounce from 'lodash/debounce';

import useRouter from 'Hooks/useRouter';

import PriceFilterComponent from 'Components/Filters/PriceFilter';

const PriceFilter = ({ onChange, options, ...props }) => {
  const [open, setOpen] = useState(true);
  const [selected, setSelected] = useState(props.selected || []);
  const groups = options.groups.reduce((acc, group) => {
    acc.low.push(group[0]);
    acc.high.push(group[1]);
    return acc;
  }, { low: [], high: [] });
  const [low, high] = props.selected;
  const [isInterval, setIsInterval] = useState(
    (
      low === options.min
      && high === options.max
    )
    || (
      (low !== undefined && !groups.low.includes(low))
      && (high !== undefined && !groups.high.includes(high))
    )
  );
  const { pathname } = useRouter();

  const handleOnToggle = () => { setOpen(prevState => !prevState); };

  useEffect(() => {
    if (
      selected.length !== props?.selected?.length
    ) {
      if (!props.selected.length) {
        setIsInterval(false);
        setSelected([]);
      } else {
        setIsInterval(
          (
            low === options.min
            && high === options.max
          )
          || (
            (low !== undefined && !groups.low.includes(low))
            && (high !== undefined && !groups.high.includes(high))
          )
        );
        setSelected(props.selected);
      }
    } else if (
      selected !== props.selected
      && selected[0] !== props.selected[0]
      && selected[1] !== props.selected[1]
    ) {
      if (!props.selected.length) {
        setIsInterval(false);
        setSelected([]);
      } else {
        const isInvl = options
          .groups
          .findIndex(
            group => (
              group[0] === selected[0]
              && group[1] === selected[1]
            )
          ) === -1;
        setIsInterval(isInvl);
        if (isInterval) {
          setSelected([]);
        }
      }
      setSelected(props.selected);
    }
  }, [props.selected]);

  const handleOnGroupChange = group => checked => {
    setIsInterval(false);
    if (checked) {
      onChange({ price: group });
      setSelected(group);
    } else {
      onChange({ price: false });
      setSelected([]);
    }
  };

  // const handleOnIntervalChange = values => {
  //   setIsInterval(true);
  //   const newPayload = [
  //     Math.floor((values[0] / 100) * options.max),
  //     Math.floor((values[1] / 100) * options.max)
  //   ];
  //
  //   if (
  //     newPayload[0] !== selected[0]
  //     || newPayload[1] !== selected[1]
  //   ) {
  //     setSelected(newPayload);
  //   }
  // };

  // useEffect(() => {
  //   if (selected.length) {
  //     handleOnIntervalAfterChange(selected);
  //   }
  // }, [selected]);

  // const handleOnIntervalAfterChange = useCallback(
  //   debounce(values => {
  //     if (
  //       values[0] !== props.selected[0]
  //       || values[1] !== props.selected[1]
  //     ) {
  //       setIsInterval(true);
  //       onChange({ price: values });
  //     }
  //   }, 250, { leading: false, trailing: true }),
  //   [props.selected]
  // );
  //
  // useEffect(() => () => handleOnIntervalAfterChange.cancel(), [props.selected]);

  const handleOnIntervalNumberChange = useCallback(
    debounce((value, type) => {
      setIsInterval(true);
      if (!value) return;
      const price = [];
      if (type === 'min') {
        price.push(parseInt(value, 10), selected[1] || options.max);
      } else {
        price.push(selected[0] || options.min, parseInt(value, 10));
      }
      onChange({ price });
      setSelected(price);
    }, 350, { leading: false, trailing: true }),
    [selected, pathname]
  );

  useEffect(() => handleOnIntervalNumberChange.cancel, [selected, pathname]);

  const handleOnActivateInterval = checked => {
    setIsInterval(checked);
    if (checked) {
      const price = [options.min, options.max];
      onChange({ price });
      setSelected(price);
    } else {
      setSelected([]);
      onChange({ price: false });
    }
  };

  const handleOnIntervalChange = values => {
    setSelected([
      Math.floor((values[0] / 100) * options.max),
      Math.floor((values[1] / 100) * options.max)
    ]);
  };

  const afterIntervalChange = () => {
    onChange({ price: selected });
  };

  return (
    <PriceFilterComponent
      open={ open }
      onToggle={ handleOnToggle }
      onGroupChange={ handleOnGroupChange }
      onIntervalChange={ handleOnIntervalChange }
      onActivateInterval={ handleOnActivateInterval }
      onIntervalAfterChange={ afterIntervalChange }
      onIntervalNumberChange={ handleOnIntervalNumberChange }
      isInterval={ isInterval }
      priceGroups={ options.groups || [] }
      selected={ selected || [] }
      sliderOptions={ { min: options.min, max: options.max } }
    />
  );
};

PriceFilter.propTypes = {
  onChange: func,
  options: object,
  selected: any
};

export default PriceFilter;
